import { DownloadApplicationButton } from '@components/button/DownloadApplicationButton';
import { Grid } from '@mui/material';
import { useQuote } from '@services/quotes';
import { useParams } from 'react-router-dom';
import invariant from 'tiny-invariant';
import Loading from '@components/Loading';
import { DownloadProposalButton } from '@components/button/DownloadApplicationButton/DownloadProposalButton';
import { useStore } from '@store/GlobalStore';
import { Button } from '@components/button/Button';
import { InsuranceProductIds } from '@models/newQuote';
import { useQuoteStore } from '@store/Quote/QuoteStore';

export const BindQuoteActionButtons = ({ onHandleOpenModal }: { onHandleOpenModal: () => void }) => {
  const { quoteId } = useParams<{ quoteId: string }>();
  const [{ isCustomerUser }] = useStore((state) => [state.userAuth]);
  const [isEndorsement] = useQuoteStore((state) => [state.isEndorsement]);
  const { quote } = useQuote(quoteId);
  const isSpecialEvent = quote?.offering.insuranceProduct.id === InsuranceProductIds.SpecialEvents;
  invariant(quoteId);

  if (!quote) {
    return <Loading />;
  }

  return (
    <Grid
      container
      size={{ xs: 12 }}
      sx={{
        justifyContent: 'center',
        marginTop: '15px',
        gap: 2,
      }}
    >
      {!isCustomerUser && (
        <>
          {!isEndorsement && (
            <>
              <DownloadProposalButton quoteId={quoteId} />
              <DownloadApplicationButton quoteId={quoteId} quoteUpdatedDate={quote?.updatedAt} />
            </>
          )}
          {isSpecialEvent && (
            <Button variant='outlined' onClick={onHandleOpenModal}>
              View Coverage Summary
            </Button>
          )}
        </>
      )}
      {isCustomerUser && isSpecialEvent && (
        <Button variant='contained' color='primary' onClick={onHandleOpenModal}>
          Review Summary of Coverage
        </Button>
      )}
    </Grid>
  );
};
